import React from "react";

const ChangeRequestPayments = () => {
  return <div>ChangeRequestPayments</div>;
};

export default ChangeRequestPayments;
